import { laboratoriesActions } from '../actions'
import ValidateFormObject, { validates } from '../utils/ValidateFormObject'
const {
  FETCH_LABORATORY,
  FETCHING_LABORATORY,
  FETCH_LABORATORY_ERROR,
  FETCH_LABORATORIES,
  FETCH_LABORATORIESALL,
  FETCHING_LABORATORIES,
  FETCH_LABORATORIES_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_LABORATORY,
  DELETE_LABORATORY,
  ADD_LABORATORY,
  EDIT_LABORATORY,
  FORM_TOUCHED,
  NEW_FORM_LABORATORY,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  LABORATORY_FORM_ERROR,
  RESET_STATE
} = laboratoriesActions

const initialState = {
  loadingLaboratory: false,
  loadingLaboratories: false,
  fetchLaboratoryError: false,
  fetchLaboratoriesError: false,
  laboratories: [],
  order: {
    column: 'nome',
    direction: 1
  },
  laboratory: {
    nome: '',
    cnpj: ''
  },
  laboratoriesPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  laboratoryFormErrors: {},
  laboratoryFormTouched: false,
  modalOpen: false
}

const laboratorySchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    },
    cnpj: {
      required: true,
      func: validates.cnpj,
      errorMessage: 'Este campo deve conter um número de CNPJ válido.'
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    },
    cnpj: {
      required: true,
      func: validates.cnpj,
      errorMessage: 'Este campo deve conter um número de CNPJ válido.'
    }
  }
}

const LaboratoryValidate = new ValidateFormObject(laboratorySchema)

const laboratories = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_LABORATORY:
      formSchemaType = action.laboratory._id ? 'edit' : 'add'
      return {
        ...state,
        laboratory: action.laboratory,
        laboratoryFormErrors: LaboratoryValidate.validate({
          formObject: action.laboratory,
          formSchemaType
        })
      }
    case LABORATORY_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.laboratory._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        laboratoryFormErrors: LaboratoryValidate.validate({
          formObject: state.laboratory,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_LABORATORY:
      return {
        ...state,
        laboratory: { ...initialState.laboratory },
        laboratoryFormErrors: LaboratoryValidate.validate({}),
        laboratoryFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        laboratoryFormTouched: true
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_LABORATORY:
      formSchemaType = (action.laboratory || {})._id ? 'edit' : 'add'
      return {
        ...state,
        laboratory: action.laboratory,
        loadingLaboratory: false,
        fetchLaboratoryError: false,
        laboratoryFormTouched: false,
        laboratoryFormErrors: LaboratoryValidate.validate({
          formObject: action.laboratory,
          formSchemaType
        })
      }
    case FETCHING_LABORATORY:
      return {
        ...state,
        loadingLaboratory: true,
        fetchLaboratoryError: false
      }
    case DELETE_LABORATORY:
      return {
        ...state,
        loadingLaboratories: false,
        fetchLaboratoryError: false,
        laboratories: state.laboratories.map(laboratory => {
          if (laboratory._id === (action.laboratory || {})._id) {
            return action.laboratory
          }
          return laboratory
        })
      }
    case FETCH_LABORATORY_ERROR:
      return {
        ...state,
        loadingLaboratories: false,
        laboratory: { ...initialState.laboratory },
        fetchLaboratoryError: action.error
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        laboratoriesPagination: {
          ...state.laboratoriesPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        laboratoriesPagination: {
          ...state.laboratoriesPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_LABORATORIES:
      return {
        ...state,
        loadingLaboratories: false,
        laboratories: action.laboratories,
        fetchLaboratoriesError: false,
        order: action.order,
        laboratoriesPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case FETCH_LABORATORIESALL:
      return {
        ...state,
        laboratories: action.laboratories
      }
    case EDIT_LABORATORY:
      return {
        ...state,
        laboratories: state.laboratories.map(laboratory => {
          if (laboratory._id === action.laboratory._id) {
            return action.laboratory
          }
          return laboratory
        }),
        loadingLaboratories: false,
        fetchLaboratoryError: false,
        loadingLaboratory: false,
        fetchLaboratoriesError: false
      }
    case FETCHING_LABORATORIES:
      return {
        ...state,
        loadingLaboratories: true,
        fetchLaboratoriesError: false
      }
    case FETCH_LABORATORIES_ERROR:
      return {
        ...state,
        loadingLaboratories: false,
        fetchLaboratoriesError: action.error,
        loadingLaboratory: false
      }
    case ADD_LABORATORY:
      return {
        ...state,
        loadingLaboratories: false,
        fetchLaboratoriesError: false,
        loadingLaboratory: false,
        laboratories: [...state.laboratories, action.laboratory]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default laboratories



// WEBPACK FOOTER //
// ./src/reducers/laboratories.js